module.exports = __webpack_public_path__ + "img/EG.7ec1ef88.png";